module.exports = __webpack_public_path__ + "img/main.19e17d5.png";